<template>
<section class="content-title">
  <div class="common-header">
    {{contentTitle}}
  </div>
  <slot></slot>
</section>
</template>
<script>
export default {
  name: 'contentTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    contentTitle () {
      return this.title || (this.$route.meta ? this.$route.meta.zhname : '')
    }
  }
}
</script>
<style lang="less">
.content-title{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  .common-header{
    padding: 8px 16px;
    font-size: 18px;
    color: #333;
    line-height: 26px;
    font-weight:bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/components/common/contentTitle.vue